import React from 'react';
import styles from './TaskList.module.css';
import {STATES} from '../lib/PageConstants';

// One row per oval, ordered by the caller (top-to-bottom on the page).
// Clicking a row selects that oval on the canvas.
const TaskList = ({tasks, selectedTaskId, onSelectTask}) => (
    <ul className={styles.list}>
        {tasks.map((task) => {
            const state = STATES[task.status] || STATES.NOT_DONE;
            const selected = task.id === selectedTaskId;
            return (
                <li key={task.id}>
                    <button
                        type="button"
                        aria-current={selected || undefined}
                        className={`${styles.row} ${selected ? styles.rowSelected : ''}`}
                        onClick={() => onSelectTask(task.id)}
                    >
                        <span className={styles.dot} style={{background: state.colour}}/>
                        <span className={styles.name}>{task.text || 'Untitled task'}</span>
                        {task.assignee ? (
                            <span className={styles.avatar} style={{background: task.assignee.colour}}>
                                {task.assignee.initials}
                            </span>
                        ) : (
                            <span className={styles.unassigned}>Unassigned</span>
                        )}
                    </button>
                </li>
            );
        })}
    </ul>
);

export default TaskList;
